import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { DatepickerDialogService } from '@libs/shared/ui/dialogs/datepicker-dialog/datepicker-dialog.service';
import { NgLetDirective } from '@libs/shared/utils/directives/ng-let/ng-let.directive';
import { DatepickerDialogComponent } from './datepicker-dialog.component';

@NgModule({
  declarations: [DatepickerDialogComponent],
  imports: [
    CommonModule,
    NgLetDirective,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ReactiveFormsModule,
  ],
  providers: [DatepickerDialogService],
})
export class DatepickerDialogModule {
  constructor(private _datepickerDialogService: DatepickerDialogService) {}
}
